import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';

const componentConfigurationKey = 'decorationLine';

interface DecorationLineComponentThemeProps {
  cardDecorationColor: string;
}

const getDecorationLineStyle = (cardDecorationColor: string) => {
  return StyleSheet.create({
    style: {
      height: '2px',
      width: '100%',
      backgroundColor: cardDecorationColor,
    },
  });
};

export const DecorationLine: React.FunctionComponent = () => {
  const { cardDecorationColor } = useTheme<DecorationLineComponentThemeProps>(componentConfigurationKey);
  const decorationLineStyle = getDecorationLineStyle(cardDecorationColor);
  return (<div className={css(decorationLineStyle.style)} />);
};
